import React, { useState } from "react";
import { Link } from "react-router-dom";
import { registerUser } from "../api";
import { useNavigate } from "react-router-dom";
import { generateOTPRegister } from "../api";
import { toast } from "react-toastify";
const RegistrationForm = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    registeremail: "",
    password: "", // remains as the key for state
    confirmPassword: "",
    verificationcode: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setConfirmShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [sendingCode, setSendingCode] = useState(false);
  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const navigate = useNavigate();
  const toggleShowConfirmPassword = () => {
    setConfirmShowPassword(!showConfirmPassword);
  };
  // Use name attribute instead of id so that the state keys remain intact.
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Validate each field when form is submitted
  const validate = () => {
    const newErrors = {};
    // Check if each field is empty and set the corresponding error message
    if (!formData.verificationcode.trim())
      newErrors.verificationcode = "Verification Code is required";
    if (!formData.firstName.trim())
      newErrors.firstName = "First Name is required";
    if (!formData.lastName.trim()) newErrors.lastName = "Last Name is required";

    if (!formData.registeremail.trim()) {
      newErrors.registeremail = "Email is required";
    } else {
      // Basic email regex validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.registeremail))
        newErrors.registeremail = "Invalid email format";
    }

    if (!formData.password) newErrors.password = "Password is required";
    if (!formData.confirmPassword) {
      newErrors.confirmPassword = "Confirm Password is required";
    } else if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const isFormComplete =
    formData.registeremail &&
    formData.verificationcode.length === 6 &&
    formData.firstName &&
    formData.lastName &&
    formData.password &&
    formData.confirmPassword;

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      // Remove confirmPassword before sending to the backend if not required by the DTO
      const { confirmPassword, registeremail, verificationcode, ...userData } =
        formData;
      const userRequestDTO = {
        ...userData,
        email: registeremail,
        verificationCode: verificationcode,
      };
      try {
        console.log("User data to be sent:", userRequestDTO);
        await registerUser(userRequestDTO);
        setFormData({
          firstName: "",
          lastName: "",
          registeremail: "",
          password: "",
          confirmPassword: "",
          verificationcode: "",
        });
        navigate("/login");
        // Additional UI handling (e.g., redirect) can be done here.
      } catch (error) {
        console.error("Error during registration:", error);
        // Additional error handling can be done here.
      }
    }
  };

  const handleGenerateOTP = async () => {
    try {
      setSendingCode(true);
      await generateOTPRegister(formData.registeremail);
      toast.success("OTP sent to your email!");
      setSendingCode(false);
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message || "Error generating OTP";
      toast.error(errorMessage);
      setSendingCode(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="border border-gray-100 hover-border-main-600 transition-1 rounded-16 px-24 py-10">
        <h6 className="text-sm mb-10">Create an account</h6>

        <div className="mb-10">
          <label
            htmlFor="email"
            className="text-neutral-900 text-sm mb-8 fw-semibold"
          >
            Email address <span className="text-danger">*</span>
          </label>
          <input
            type="email"
            className="common-input-two text-sm"
            id="registeremail"
            name="registeremail"
            placeholder="Enter Email Address"
            value={formData.registeremail}
            onChange={handleChange}
            required
          />
          {errors.registeremail && (
            <div className="text-danger">{errors.registeremail}</div>
          )}
        </div>
        <button
          type="button"
          onClick={handleGenerateOTP}
          disabled={!isValidEmail(formData.registeremail)}
          className="btn btn-sm btn-danger mb-4" // add your preferred styling class
        >
          {sendingCode ? "Sending..." : "Send OTP"}
        </button>

        <div className="mb-10">
          <label
            htmlFor="verificationcode"
            className="text-neutral-900 text-sm mb-8 fw-semibold"
          >
            Verification Code <span className="text-danger">*</span>
          </label>
          <input
            type="number"
            className="common-input-two text-sm"
            id="verificationcode"
            name="verificationcode"
            placeholder="Enter Verification Code"
            value={formData.verificationcode}
            onChange={handleChange}
            required
          />
          {errors.verificationcode && (
            <div className="text-danger">{errors.verificationcode}</div>
          )}
        </div>
        {/* First Name */}
        <div className="mb-10">
          <label
            htmlFor="firstName"
            className="text-neutral-900 text-sm mb-8 fw-semibold"
          >
            First Name <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className="common-input-two text-sm"
            id="firstName"
            name="firstName"
            placeholder="Enter First Name"
            value={formData.firstName}
            onChange={handleChange}
            disabled={formData.verificationcode.length !== 6}
            required
          />
          {errors.firstName && (
            <div className="text-danger">{errors.firstName}</div>
          )}
        </div>

        {/* Last Name */}
        <div className="mb-10">
          <label
            htmlFor="lastName"
            className="text-neutral-900 text-sm mb-8 fw-semibold"
          >
            Last Name <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className="common-input-two text-sm"
            id="lastName"
            name="lastName"
            placeholder="Enter Last Name"
            value={formData.lastName}
            onChange={handleChange}
            disabled={formData.verificationcode.length !== 6}
            required
          />
          {errors.lastName && (
            <div className="text-danger">{errors.lastName}</div>
          )}
        </div>

        <div className="mb-10">
          <label
            htmlFor="passwordtwo"
            className="text-neutral-900 text-sm mb-8 fw-semibold"
          >
            Password <span className="text-danger">*</span>
          </label>
          <div className="position-relative">
            <input
              type={showPassword ? "text" : "password"}
              className="common-input-two text-sm"
              id="passwordtwo"
              name="password"
              placeholder="Enter Password"
              value={formData.password}
              onChange={handleChange}
              disabled={formData.verificationcode.length !== 6}
              required
            />
            <span
              className="toggle-password position-absolute top-50 inset-inline-end-0 me-16 translate-middle-y cursor-pointer text-sm"
              id="togglePasswordtwo"
              onClick={toggleShowPassword}
            >
              {showPassword ? "Hide" : "Show"}
            </span>
          </div>
          {errors.password && (
            <div className="text-danger">{errors.password}</div>
          )}
        </div>

        {/* Confirm Password */}
        <div className="mb-10">
          <label
            htmlFor="confirmPassword"
            className="text-neutral-900 text-sm mb-8 fw-semibold"
          >
            Confirm Password <span className="text-danger">*</span>
          </label>
          <div className="position-relative">
            <input
              type={showConfirmPassword ? "text" : "password"}
              className="common-input-two text-sm"
              id="confirmPassword"
              name="confirmPassword"
              placeholder="Confirm Password"
              value={formData.confirmPassword}
              onChange={handleChange}
              disabled={formData.verificationcode.length !== 6}
              required
            />
            <span
              className="toggle-password position-absolute top-50 inset-inline-end-0 me-16 translate-middle-y cursor-pointer text-sm"
              id="togglePasswordtwo"
              onClick={toggleShowConfirmPassword}
            >
              {showConfirmPassword ? "Hide" : "Show"}
            </span>
          </div>
          {errors.confirmPassword && (
            <div className="text-danger">{errors.confirmPassword}</div>
          )}
        </div>

        <div className="mt-10">
          <p className="text-gray-500 text-sm">
            Your personal data will be used to process your order, support your
            experience throughout this website, and for other purposes described
            in our{" "}
            <Link
              to="/privacy-policy"
              className="text-main-600 text-decoration-underline"
            >
              privacy policy
            </Link>
            .
          </p>
        </div>
        <div className="mt-10">
          <button
            type="submit"
            className="btn btn-main btn-sm"
            disabled={!isFormComplete}
          >
            Register
          </button>
        </div>
      </div>
    </form>
  );
};

export default RegistrationForm;
